<template>
  <el-dialog
    class="project-progress"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal="false"
    width="calc(100vw - 200px)"
  >
    <Header slot="title" :project="project" :step="step"></Header>
    <Title :project="project" :step="step"></Title>
    <div class="project-progress-content">
      <div class="project-progress-content-left">
        <div v-if="step !== '离职管理' && step !== '开票催款'" class="dialog-header-box">
          <div v-if="step === '职位推荐'">
            <p class="dialog-title">客户对候选人整体推荐反馈</p>
            <div class="input-box">
              <div class="input-box-left" style="padding-top:10px">
                <el-button
                  v-if="!isCustomerManager"
                  class="mb10"
                  type="primary"
                  size="mini"
                  plain
                  @click="toEditFeedBack"
                  >填写反馈</el-button
                >
                <el-button class="mb10" type="primary" size="mini" plain @click="modifyProjectTag"
                  >修改项目标签</el-button
                >
              </div>
              <div class="input-box-right">
                <FeedBackEditor
                  ref="FeedBackEditor1"
                  :histories="project.客户经理人选反馈"
                  :edit-visible="editingFeedBack"
                  @addFeedBack="val => addFeedBack(val, '客户经理人选反馈')"
                ></FeedBackEditor>
                <!-- <el-input
                  v-model="project.客户经理人选反馈"
                  class="flex-grow"
                  type="textarea"
                  size="mini"
                  :rows="3"
                  placeholder=""
                >
                </el-input>
                <div class="textarea-btn-box">
                  <el-button type="primary" size="mini" plain @click="saveFeedBack">保存</el-button>
                </div> -->
              </div>
            </div>
          </div>
          <div v-if="step === '面试阶段'">
            <p class="dialog-title">客户对项目整体的面试反馈</p>
            <div class="input-box">
              <div class="input-box-left" style="padding-top:10px">
                <el-button
                  v-if="!isCustomerManager"
                  class="mb10"
                  type="primary"
                  size="mini"
                  plain
                  @click="toEditProjectFeedBack"
                  >填写反馈</el-button
                >
                <el-button class="mb10" type="primary" size="mini" plain @click="modifyProjectTag"
                  >修改项目标签</el-button
                >
              </div>
              <div class="input-box-right">
                <FeedBackEditor
                  ref="FeedBackEditor2"
                  :histories="project.客户对项目反馈"
                  :edit-visible="editingProjectFeedBack"
                  @addFeedBack="val => addFeedBack(val, '客户对项目反馈')"
                ></FeedBackEditor>
                <!-- <el-input
                  v-model="project.客户对项目反馈"
                  class="flex-grow"
                  type="textarea"
                  size="mini"
                  :rows="3"
                  placeholder=""
                >
                </el-input>
                <div class="textarea-btn-box">
                  <el-button type="primary" size="mini" plain @click="saveProjectFeedBack">保存</el-button>
                </div> -->
              </div>
            </div>
          </div>
          <div v-if="step === 'offer谈判'">
            <p class="dialog-title">客户对项目offer反馈</p>
            <div class="input-box" style="width: 100%;">
              <FeedBackEditor
                ref="FeedBackEditor3"
                :histories="project.项目offer反馈"
                placeholder="请输入客户对于项目的整体反馈"
                :edit-visible="true"
                @addFeedBack="val => addFeedBack(val, '项目offer反馈')"
              ></FeedBackEditor>
            </div>
          </div>
        </div>
        <div v-if="!['offer谈判', '离职管理', '开票催款'].includes(step)" class="dialog-content">
          <div class="dialog-content-left">
            <RadishInProjectList
              ref="RadishInProjectList"
              :project="project"
              :step="step"
              @currentRow="getCurrentRow"
              @showRadishProgress="showRadishProgress"
            ></RadishInProjectList>
          </div>
          <div class="dialog-content-right">
            <Recommend
              v-if="step === '职位推荐'"
              :project="project"
              :step="step"
              :radish-project="currentRow"
              @reloadProject="reloadProject"
              @removeRecommend="removeRecommend"
            ></Recommend>
            <Interview
              v-if="step === '面试阶段'"
              :project="project"
              :step="step"
              :radish-project="currentRow"
              @reloadProject="reloadProject"
              @removeInterview="removeInterview"
            ></Interview>
          </div>
        </div>
        <div v-else class="dialog-content">
          <RadishInProjectListComplete
            ref="RadishInProjectListComplete"
            :project="project"
            :step="step"
            @currentRow="getCurrentRow"
            @reloadProject="reloadProject"
          ></RadishInProjectListComplete>
        </div>
      </div>
      <div class="project-progress-content-right">
        <ProjectSteps ref="ProjectSteps" background-color='#eee' :project="project" :step="step"></ProjectSteps>
      </div>
    </div>
    <RadishProgress ref="RadishProgress"></RadishProgress>
    <!-- <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">取 消</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirm">确 定</div>
    </span> -->
  </el-dialog>
</template>
<script>
import Header from './Header'
import Title from './Title'
import FeedBackEditor from './FeedBackEditor'
import RadishInProjectList from './RadishInProjectList'
import RadishInProjectListComplete from './RadishInProjectListComplete'
import ProjectSteps from './ProjectSteps'
import Recommend from './Recommend'
import Interview from './Interview'
import RadishProgress from '../../../../radish/src/progress/radish-progress'
import project_notify from '../../../../radish/src/constant/project_notify'

const dateFormat = require('dateformat')

export default {
  components: {
    Header,
    Title,
    FeedBackEditor,
    RadishInProjectList,
    RadishInProjectListComplete,
    ProjectSteps,
    Recommend,
    Interview,
    RadishProgress,
  },
  data() {
    return {
      dialogVisible: false,
      project: {},
      step: null,
      projectDetail: [],
      radishProjectDetail: {},
      editingFeedBack: false,
      editingProjectFeedBack: false,
      currentRow: {},
    }
  },
  computed: {
    defaultTab() {
      return this.$route.query.tab || ''
    },
    isCustomerManager() {
      const manger = this.project.客户开发 || []
      const flag = manger.includes(app.user.account)
      if (flag) {
        this.toEditFeedBack()
        this.toEditProjectFeedBack()
      }
      return flag
    },
  },
  watch: {
    $route(to, from) {
      this.dialogVisible = false
    },
  },
  methods: {
    checkFeedbackBadge() {
      const fieldMap = {
        职位推荐: '客户经理人选反馈',
        面试阶段: '客户对项目反馈',
        offer谈判: '项目offer反馈',
      }
      const account = app.user.account

      const { project, step } = this
      const field = fieldMap[step]
      if (!field) return

      const storage = localStorage.getItem('projectHistory')
      const obj = (storage && JSON.parse(storage)) || {}
      const projectStorage = obj[project._id] || {}

      let updateStorageFlag = false

      const feedbacks = this.project[field] || []
      const oldFeedbacks = projectStorage[field] || []

      feedbacks.forEach(val => {
        // 查找填写数据的是当前用户，或者历史查记录中是否包含此条数据的，如果找到，说明不用显示红点
        const a = val.user === account || oldFeedbacks.find(v => JSON.stringify(v) === JSON.stringify(val))
        this.$set(val, 'badge', !a)
        if (!a) updateStorageFlag = true
      })

      if (updateStorageFlag) this.updateProjectStorage(field, feedbacks)
    },
    updateProjectStorage(field, arr) {
      const copyArr = window._.cloneDeep(arr)
      copyArr.forEach(val => {
        delete val.badge
      })
      // const badgeFields = ['客户经理人选反馈','客户对项目反馈']
      const storage = localStorage.getItem('projectHistory')
      let obj = {}
      try {
        obj = (storage && JSON.parse(storage)) || {}
      } catch (e) {
        console.log(e)
      }

      obj[this.project._id] = obj[this.project._id] || {}
      obj[this.project._id][field] = copyArr
      localStorage.setItem('projectHistory', JSON.stringify(obj))
    },
    showRadishProgress(row) {
      this.$refs.RadishProgress.open({ pid: row.pid, rid: row.rid, logOnly: true })
    },
    async addFeedBack(feedback, field) {
      const option = { pid: this.project._id, feedback, field }
      const res = await app.service('project').addProjectFeedBack(option)
      if (res.status === 'success') {
        this.$set(this.project, field, res.data[field])
        // Object.assign(this.project, { [field]: res.data[field] })
        if (field === '客户经理人选反馈') this.$refs.FeedBackEditor1.clear()
        else if (field === '客户对项目反馈') this.$refs.FeedBackEditor2.clear()
        else this.$refs.FeedBackEditor3.clear()
        if (field === '客户对项目反馈') {
          project_notify.sendMessage3(
            this.project._id,
            '-面试反馈',
            '面试反馈3',
            { 客户对项目反馈: feedback.content },
            '项目成员',
          )
        } else if (field === '项目offer反馈') {
          project_notify.sendMessage3(this.project._id, '-offer谈判', 'offer谈判', { 项目offer反馈: feedback.content })
        }
      } else this.$message.error(res.msg)
    },
    modifyProjectTag() {
      window.open(`${window.origin}/#/project20/${this.project._id}?defaultActiveTab=详情`)
    },
    removeRecommend(radishProject) {
      this.$refs.RadishInProjectList.removeRow(radishProject)
    },
    removeInterview(radishProject) {
      this.$refs.RadishInProjectList.removeRow(radishProject)
    },
    reloadProject(project) {
      // this.$emit('reloadProject', project)
      this.parentReloadProject && this.parentReloadProject(project)
    },
    getCurrentRow(row) {
      this.currentRow = row
    },
    toEditFeedBack() {
      this.editingFeedBack = true
    },
    toEditProjectFeedBack() {
      this.editingProjectFeedBack = true
    },
    saveFeedBack() {
      this.updateProject({ 客户经理人选反馈: this.project['客户经理人选反馈'] })
    },
    saveProjectFeedBack() {
      this.updateProject({ 客户对项目反馈: this.project['客户对项目反馈'] })
    },
    async updateProject(param) {
      if (!this.project._id) return
      try {
        await window.app.service('project').modify({
          id: this.project._id,
          param,
        })
        Object.assign(this.project, param)
        this.$message({ type: 'success', message: `修改成功` })
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
    confirm() {
      this.dialogVisible = false
    },
    async open(project, step, reloadProject) {
      this.project = project
      this.step = step
      this.dialogVisible = true
      this.parentReloadProject = reloadProject || function() {}
      this.checkProjectDetail()
      this.refreshComponent()
      if (step === '人才搜寻') this.countRadishes()
      this.checkFeedbackBadge()
    },
    refreshComponent() {
      this.$refs.RadishInProjectList && this.$refs.RadishInProjectList.getList()
      this.$refs.RadishInProjectListComplete && this.$refs.RadishInProjectListComplete.getList()
      this.$refs.ProjectSteps && this.$refs.ProjectSteps.refresh()
    },
    async countRadishes() {
      const searchRadishDetail = {}
      const radishProject = this.project.radish_project || []

      searchRadishDetail.已搜寻 = radishProject.length
      const haveContacted = radishProject.filter(v => v.意向)
      searchRadishDetail.已沟通 = haveContacted.length
      const res = await app.service('radish').findByIds({ ids: radishProject.map(item => item.rid) })
      if (res.status === 'success') {
        const radishes = res.data
        searchRadishDetail.行业 = radishes.map(val => val.行业).filter(val => val)
        searchRadishDetail.公司 = radishes.map(val => val.公司).filter(val => val)
      } else this.$message.error(res.msg)
      const setObjIndustry = new Set(searchRadishDetail.行业)
      const setObjCompany = new Set(searchRadishDetail.公司)
      searchRadishDetail.行业 = [...setObjIndustry]
      searchRadishDetail.公司 = [...setObjCompany]
      this.radishProjectDetail = searchRadishDetail
    },
    checkProjectDetail() {
      const result = []
      const map = {
        项目JD: ['岗位职责', '岗位要求'],
        核心要求: ['核心要求'],
        客户关心问题: ['关注问题'],
        寻访方向: ['寻访方向'],
        客户关键决策人: ['关键面试人'],
        // '优势亮点（公司）':[],
        '优势亮点（项目）': ['职位亮点及优势'],
        阿尔法对公司认知: ['阿尔法认知'],
        面试流程及安排: ['面试安排'],
        项目标签: ['职能模块', '擅长方向', '细分职能', '目标行业', '平台', '职级', '业绩', '地域', '年龄要求', '标签'],
      }
      for (const label in map) {
        const fields = map[label]
        const obj = { label, value: false }
        fields.forEach(field => {
          const val = this.project[field]
          if (Array.isArray(val)) {
            if (val.length !== 0) obj.value = true
          } else if (val) obj.value = true
        })
        result.push(obj)
      }
      this.projectDetail = result
    },
    dateFormat(time, format) {
      return dateFormat(time, format)
    },
  },
}
</script>
<style>
.project-progress .el-dialog {
  display: flex;
  flex-direction: column;
}
.project-progress .el-dialog .el-dialog__body {
  overflow: auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.project-progress .el-dialog .el-dialog__body .content {
  overflow: auto;
  flex-grow: 1;
}
</style>
<style scoped>
.project-progress {
  z-index: 1001 !important;
}
.bolder {
  font-weight: 700;
}
.dialog-header-box {
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  box-shadow: 1px 0px 8px 0 rgba(213, 215, 220, 0.6), 0 2px 4px 0 rgba(201, 203, 211, 0.5);
}
.keep-all {
  word-break: keep-all;
  white-space: nowrap;
}
.project-detail-box {
  padding-top: 15px;
  display: flex;
  flex-wrap: wrap;
}
.project-detail {
  width: 25%;
  display: flex;
  align-items: center;
  padding: 6px;
}
.input-box {
  display: flex;
}
.input-box-left,
.input-box-right {
  display: flex;
  flex-direction: column;
}
.input-box-right {
  flex-grow: 1;
  padding: 6px;
}
.textarea-btn-box {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.project-progress-content {
  display: flex;
}
.project-progress-content-left {
  overflow: auto;
  flex-grow: 1;
  padding: 4px 10px;
}
.project-progress-content-right {
  width: 255px;
  background-color: #eee;
  padding: 10px 4px;
  flex: none;
}
.dialog-content {
  display: flex;
  padding-top: 10px;
}
.dialog-content-right {
  flex-grow: 1;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  margin-left: 5px;
  box-shadow: 1px 0px 8px 0 rgba(213, 215, 220, 0.6), 0 2px 4px 0 rgba(201, 203, 211, 0.5);
}
.dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #4a4848;
  margin-bottom: 10px;
}
</style>
